import _classCallCheck from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/ui/text_box/texteditor_button_collection/button.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../core/renderer";

var TextEditorButton =
/*#__PURE__*/
function () {
  function TextEditorButton(name, editor, options) {
    _classCallCheck(this, TextEditorButton);

    this.instance = null;
    this.$container = null;
    this.$placeMarker = null;
    this.editor = editor;
    this.name = name;
    this.options = options || {};
  }

  _createClass(TextEditorButton, [{
    key: "_addPlaceMarker",
    value: function _addPlaceMarker($container) {
      this.$placeMarker = $("<div>").appendTo($container);
    }
  }, {
    key: "_addToContainer",
    value: function _addToContainer($element) {
      var $placeMarker = this.$placeMarker,
          $container = this.$container;
      $placeMarker ? $placeMarker.replaceWith($element) : $element.appendTo($container);
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents() {
      throw "Not implemented";
    }
  }, {
    key: "_create",
    value: function _create() {
      throw "Not implemented";
    }
  }, {
    key: "_isRendered",
    value: function _isRendered() {
      return !!this.instance;
    }
  }, {
    key: "_isVisible",
    value: function _isVisible() {
      var editor = this.editor,
          options = this.options;
      return options.visible || !editor.option("readOnly");
    }
  }, {
    key: "_isDisabled",
    value: function _isDisabled() {
      throw "Not implemented";
    }
  }, {
    key: "_shouldRender",
    value: function _shouldRender() {
      return this._isVisible() && !this._isRendered();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var instance = this.instance,
          $placeMarker = this.$placeMarker;

      if (instance) {
        instance.dispose ? instance.dispose() : instance.remove();
        this.instance = null;
      }

      $placeMarker && $placeMarker.remove();
    }
  }, {
    key: "render",
    value: function render() {
      var $container = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.$container;
      this.$container = $container;

      if (this._isVisible()) {
        var _this$_create = this._create(),
            instance = _this$_create.instance,
            $element = _this$_create.$element;

        this.instance = instance;

        this._attachEvents(instance, $element);
      } else {
        this._addPlaceMarker($container);
      }
    }
  }, {
    key: "update",
    value: function update() {
      if (this._shouldRender()) {
        this.render();
      }

      return !!this.instance;
    }
  }]);

  return TextEditorButton;
}();

export { TextEditorButton as default };